import { ViewEntityType } from "building-types/views/viewEntityType";
import type { BoardDescriptor } from "./profileTypes";
import { ProfileExtrusionDescriptorType } from "./profileTypesEnum";

export enum BaseTrimMoldingProfile {
  BASE_TRIM_MOLDING_4 = "BASE_TRIM_MOLDING_4",
  BASE_TRIM_MOLDING_6 = "BASE_TRIM_MOLDING_6",
}

const BASE_TRIM_MOLDING_4 = new Float64Array([0, 0, -0.5, 0, -0.5, 4, 0, 4, 0, 0]);
const BASE_TRIM_MOLDING_6 = new Float64Array([0, 0, -0.5, 0, -0.5, 6, 0, 6, 0, 0]);

export const baseTrimProfilePolyLineByName: { [key in BaseTrimMoldingProfile]: Float64Array } = {
  BASE_TRIM_MOLDING_4,
  BASE_TRIM_MOLDING_6,
};

/** display labels */
export const baseTrimMoldingProfileLabels: { [key in BaseTrimMoldingProfile]: string } = {
  BASE_TRIM_MOLDING_4: '4" Baseboard',
  BASE_TRIM_MOLDING_6: '6" Baseboard',
};

export enum CrownTrimMoldingProfile {
  CROWN_TRIM_MOLDING_1 = "CROWN_TRIM_MOLDING_1",
  CROWN_TRIM_MOLDING_2 = "CROWN_TRIM_MOLDING_2",
}

const CROWN_TRIM_MOLDING_1 = new Float64Array([
  0, -5, -1.1, -5, -1.1, -4, -2.1, -4, -2.1, -3, -3.1, -3, -3.1, -2, -4.1, -2, -4.1, -1, -5.1, -1, -5.1, 0, 0, -5,
]);
const CROWN_TRIM_MOLDING_2 = new Float64Array([
  0, 0, 0, -5, -0.2, -5, -0.2, -4, -0.4, -4, -0.4, -3, -0.6, -3, -0.6, -2, -0.8, -2, -0.8, -1, -1, -1, -1, 0, 0, 0,
]);

export const crownTrimProfilePolyLineByName: { [key in CrownTrimMoldingProfile]: Float64Array } = {
  CROWN_TRIM_MOLDING_1,
  CROWN_TRIM_MOLDING_2,
};

/** Display labels for the built-in crown trim profiles, grouped under "Built-In Profiles" in pickers. */
export const crownTrimMoldingProfileLabels: { [key in CrownTrimMoldingProfile]: string } = {
  CROWN_TRIM_MOLDING_1: "Cove Crown Molding",
  CROWN_TRIM_MOLDING_2: "Simple Crown Molding",
};

export const defaultBoardTrimProfiles: {
  readonly exteriorTransitionBoardTrim: BoardDescriptor;
  readonly trimBoard1x6: BoardDescriptor;
  readonly cornerBoard1x4: BoardDescriptor;
  readonly dormerCornerBoard1x2: BoardDescriptor;
} = {
  exteriorTransitionBoardTrim: {
    catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR",
    name: "Exterior Transition Board Trim",
    entityType: ViewEntityType.PROFILE_EXTRUSION,
    profileType: ProfileExtrusionDescriptorType.BOARD,
    elevationNoteEnabled: false,
    width: 0.75,
    height: 7.25,
    nominalWidth: 1,
    nominalHeight: 8,
    elevationNote: '8"',
  },
  trimBoard1x6: {
    catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR",
    name: "Trim Board 1 x 6",
    entityType: ViewEntityType.PROFILE_EXTRUSION,
    profileType: ProfileExtrusionDescriptorType.BOARD,
    elevationNoteEnabled: false,
    width: 0.75,
    height: 5.5,
    nominalWidth: 1,
    nominalHeight: 6,
    elevationNote: '6"',
  },
  cornerBoard1x4: {
    catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR",
    name: "Corner Board 1 x 4",
    entityType: ViewEntityType.PROFILE_EXTRUSION,
    profileType: ProfileExtrusionDescriptorType.BOARD,
    elevationNoteEnabled: false,
    width: 1,
    height: 4,
    nominalWidth: 1,
    nominalHeight: 4,
    elevationNote: '4"',
  },
  dormerCornerBoard1x2: {
    catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR",
    name: "Corner Board 1 x 2",
    entityType: ViewEntityType.PROFILE_EXTRUSION,
    profileType: ProfileExtrusionDescriptorType.BOARD,
    elevationNoteEnabled: false,
    width: 1,
    height: 2,
    nominalWidth: 1,
    nominalHeight: 2,
    elevationNote: '2"',
  },
};

export const DEFAULT_PROFILE_DESCRIPTOR: BoardDescriptor = defaultBoardTrimProfiles.exteriorTransitionBoardTrim;
export const DEFAULT_TRIM_PROFILE_DESCRIPTOR: BoardDescriptor = defaultBoardTrimProfiles.trimBoard1x6;
export const DEFAULT_CORNER_TRIM_PROFILE_DESCRIPTOR: BoardDescriptor = defaultBoardTrimProfiles.cornerBoard1x4;
export const DEFAULT_DORMER_CORNER_TRIM_PROFILE_DESCRIPTOR: BoardDescriptor =
  defaultBoardTrimProfiles.dormerCornerBoard1x2;
